"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
const styles = (theme) => (0, styles_1.createStyles)({
    container: material_kit_pro_react_1.container,
    coloredShadow: material_kit_pro_react_1.coloredShadow,
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    header: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    },
    imageContainer: {
        overflow: 'hidden',
        maxHeight: 480,
        [theme.breakpoints.down('lg')]: {
            maxHeight: 450
        },
        [theme.breakpoints.down('md')]: {
            maxHeight: 400
        },
        [theme.breakpoints.down('xs')]: {
            maxHeight: 360
        }
    },
    tabSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    noBottomSpacing: {
        paddingBottom: '0 !important'
    },
    progressiveInnerContent: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2)
    }
});
exports.default = styles;
//# sourceMappingURL=DrawsScreenStyle.js.map